import { NOTIFICATION_ACTION_TYPES } from '../actions/notification'

const defaultState = {
  show: false,
  message: '',
}

const { NOTIFICATION_HIDE, NOTIFICATION_SHOW } = NOTIFICATION_ACTION_TYPES

const notificationReducer = (state = defaultState, action = {}) => {
  switch (action.type) {
    case NOTIFICATION_SHOW:
      return {
        ...state,
        show: true,
        cta: action.payload.cta,
        theme: action.payload.theme,
        message: action.payload.message,
      }
    case NOTIFICATION_HIDE:
      return {
        ...state,
        show: false,
        cta: action.payload.cta,
        message: '',
      }
    default:
      return state
  }
}

export default notificationReducer
